import { List, ListItem, ListIcon, Text } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

export default [
  <>
    {/* Édition & Formulaires */}
    <Text fontWeight='bold' mb={2}>
      ✏️ Édition & Formulaires
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Mise à jour des champs directement depuis le tableau avec un{' '}
        <b>clic droit</b>.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Nouvel affichage des formulaires avec découpage par{' '}
        <b>groupe de champs</b> et ajout de <b>titres</b> (via le mode édition).
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Les champs obligatoires empêchent maintenant l’envoi du formulaire s’ils
        ne sont pas remplis.
      </ListItem>
    </List>

    {/* Affichage & Planning */}
    <Text fontWeight='bold' mb={2}>
      📅 Affichage & Planning
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Les options et sous-onglets peuvent être visibles selon le rôle.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Les filtres et le champ de recherche sont désormais disponibles dans la
        page planning.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Légende colorée en fonction du type de RDV ajoutée dans le planning pour
        plus de clarté.
      </ListItem>
    </List>

    {/* Gestion des documents */}
    <Text fontWeight='bold' mb={2}>
      📂 Gestion des documents
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Possibilité de découper un PDF contenant plusieurs types de documents et
        de les ranger directement dans les bonnes catégories.
      </ListItem>
    </List>

    {/* Améliorations diverses */}
    <Text fontWeight='bold' mb={2}>
      ⚡ Autres améliorations
    </Text>
    <List spacing={2}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Ajout automatique de colonnes datées avec la dernière modification, au
        format <b>DD/MM/YYYY</b> ou <b>il y a x minutes</b>.
      </ListItem>
    </List>
  </>,
  <>
    {/* Écran de Login & Authentification */}
    <Text fontWeight='bold' mb={2}>
      🔑 Login & Authentification
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Mise à jour de l’interface de <b>connexion</b>.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Authentification avec sélection de la société.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Gestion des push notifications (notifications natives sur desktop et
        mobile).
      </ListItem>
    </List>

    {/* Écran Dashboard & Planning */}
    <Text fontWeight='bold' mb={2}>
      📊 Dashboard & Planning
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Affichage du <b>week-end</b> dans le calendrier.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Ajout de boutons d’<b>actions rapides</b> et de <b>raccourcis</b> avec
        le <b>clic droit</b> sur les tableaux.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Nouveaux boutons pour les <b>actions multiples</b>.
      </ListItem>
    </List>

    {/* Écran Formulaires & Édition */}
    <Text fontWeight='bold' mb={2}>
      ✏️ Formulaires & Édition
    </Text>
    <List spacing={2} mb={4}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Affichage des icônes dans les onglets lorsqu’une <b>erreur</b> est
        détectée dans les <b>formulaires</b>.
      </ListItem>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Possibilité d’ajouter des <b>KPIs</b> sur les pages clonées.
      </ListItem>
    </List>

    {/* Écran Documents & PDF */}
    {/* 
  <Text fontWeight='bold' mb={2}>
    📂 Documents & PDF
  </Text>
  <List spacing={2} mb={4}>
    <ListItem>
      <ListIcon as={CheckCircleIcon} color='green.500' />
      Intégration complète du <b>workflow de signature PDF</b> avec notifications en temps réel.
    </ListItem>
    <ListItem>
      <ListIcon as={CheckCircleIcon} color='green.500' />
      Nouveau générateur de PDF avec options de signataires, modal PDF et chemin de stockage généré automatiquement.
    </ListItem>
    <ListItem>
      <ListIcon as={CheckCircleIcon} color='green.500' />
      Support du nouveau mode PDF avec champs fusionnés et visualisation intégrée.
    </ListItem>
    <ListItem>
      <ListIcon as={CheckCircleIcon} color='green.500' />
      Nouvelle <b>visionneuse de fichiers</b> pour prévisualiser les documents et PDF directement dans l’application.
    </ListItem>
  </List>
  */}

    {/* Écran UI & Design */}
    <Text fontWeight='bold' mb={2}>
      🎨 UI, Thèmes & Design
    </Text>
    <List spacing={2}>
      <ListItem>
        <ListIcon as={CheckCircleIcon} color='green.500' />
        Mise à jour globale de l’UI avec de nouveaux thèmes et couleurs.
      </ListItem>
    </List>
  </>,
] as JSX.Element[];
